export default __webpack_public_path__ + "static/media/login.753498d3.svg";